import type {
  IAiSpreadsheetCell,
  IAiSpreadsheetLoadedSheet,
} from "@/payroll/ai-script/types";
import { calculatePracticeCells } from "./practice-formulas";

export const makePracticeWorkbook = (
  bonus: number,
  edits: Record<string, string> = {},
): IAiSpreadsheetLoadedSheet => {
  const values = [
    ["Employee", "Base pay", "Bonus", "Total pay"],
    ["Alex Morgan", 1200, bonus, 1200 + bonus],
    ["Jamie Chen", 1350, 150, 1500],
    ["Sam Rivera", 1100, 100, 1200],
    ["Total", 3650, bonus + 250, 3900 + bonus],
  ];
  const cells: IAiSpreadsheetCell[] = values.flatMap((row, rowIndex) =>
    row.map((value, columnIndex) => {
      const isFormula =
        rowIndex > 0 &&
        (columnIndex === 3 || (rowIndex === 4 && columnIndex > 0));
      const formula =
        rowIndex === 4
          ? `=SUM(${String.fromCharCode(65 + columnIndex)}2:${String.fromCharCode(65 + columnIndex)}4)`
          : `=B${rowIndex + 1}+C${rowIndex + 1}`;
      const rawInput =
        edits[`${rowIndex + 1}:${columnIndex + 1}`] ??
        (isFormula ? formula : String(value));
      return {
        id: `${rowIndex + 1}:${columnIndex + 1}`,
        ai_spreadsheet_sheet_id: "help-practice",
        row: rowIndex + 1,
        col: columnIndex + 1,
        kind: rawInput.trim().startsWith("=") ? "formula" : "value",
        raw_input: rawInput,
        computed_value: value,
        value_type: typeof value === "number" ? "currency" : "text",
        format: {
          bold: rowIndex === 0 || rowIndex === 4,
          ...(typeof value === "number" ? { format_code: "$#,##0.00" } : {}),
        },
        locked: false,
        error: null,
        accessor_key: null,
        source_ref: null,
        suggested_values: null,
        edited_by_admin_user_id: null,
        edited_at: null,
        created_at: "",
        updated_at: "",
      };
    }),
  );
  return {
    id: "help-practice",
    ai_spreadsheet_id: "help-practice",
    name: "Weekly payroll",
    recipient_external_id: null,
    access_key: null,
    editable: true,
    loaded: true,
    cell_count: cells.length,
    empty: false,
    rerun_scopable: false,
    position: 0,
    column_widths: { "1": 25, "2": 18, "3": 18, "4": 18 },
    row_heights: null,
    frozen_column: null,
    created_at: "",
    updated_at: "",
    cells: calculatePracticeCells(cells),
  };
};
